// extracted by mini-css-extract-plugin
module.exports = {"z-index-header":"10","black":"hsl(0, 0%, 0%)","wrapper":"style--wrapper--e218c5","fullpage":"style--fullpage--32cb6d"};